import {
  faCaretDown,
  faCaretRight,
  faClipboardList,
  faClock,
  faEllipsis,
  faFile,
  faFolder,
  faGear,
  faLayerGroup,
  faPenToSquare,
  faTrash,
  faUsers,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  Badge,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap'
import FormSubmissions from './FormSubmissions'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateFormTitle } from 'store/Forms/actions'
import { updateSection } from 'store/Forms/actions'
import TakeFormModal from './TakeFormModal'
import './formContainer.css'

function FormContainer({
  form,
  setShowEditFormModal,
  setShowAssignUsersModal,
  setShowFormSettingsModal,
  setShowFormSubmissionsModal,
  setFormId,
  children,
  deleteForm,
  lastForm,
  onSectionClick,
  onEditClick,
  autoFillFormId,
  removeFillFormFromUrl,
}) {
  const dispatch = useDispatch()
  const { user } = useSelector((store) => store.auth)

  const { selectedLocation, selectedStatus, selectedStartDate } = useSelector(
    (store) => store.form
  )
  const [showFormSubmissions, setShowFormSubmissions] = useState(false)
  const [isEditingTitle, setIsEditingTitle] = useState(false)
  const [hasSubmissions, setHasSubmissions] = useState(form?.has_submissions)

  const [formTitle, setFormTitle] = useState(form?.title || 'Untitled Form')

  const [showTakeFormModal, setShowTakeFormModal] = useState(false)
  const [submissionsRefreshKey, setSubmissionsRefreshKey] = useState(0)

  useEffect(() => {
    if (selectedLocation || selectedStatus || selectedStartDate)
      setShowFormSubmissions(true)
  }, [selectedLocation, selectedStatus, selectedStartDate])

  const handleTitleSave = () => {
    if (formTitle !== form?.title) {
      dispatch(updateFormTitle(form.id, formTitle))
    }
    setIsEditingTitle(false)
  }

  const handleTitleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.target.blur() // Trigger onBlur to save
    }
    if (e.key === 'Escape') {
      setFormTitle(form?.title || 'Untitled Form') // Reset to original
      setIsEditingTitle(false)
    }
  }

  useEffect(() => {
    if (!selectedLocation && !selectedStatus && !selectedStartDate) {
      setHasSubmissions(form?.has_submissions)
    }
  }, [
    form?.has_submissions,
    selectedLocation,
    selectedStartDate,
    selectedStatus,
  ])

  // Handle auto-opening TakeFormModal from URL parameter
  useEffect(() => {
    if (autoFillFormId && autoFillFormId === form.id && !form?.is_section) {
      setShowTakeFormModal(true)
    }
  }, [autoFillFormId, form.id, form?.is_section])

  return (
    <>
      <div
        key={form.id}
        className={`d-flex align-items-center justify-content-between border-bottom px-5 form-container ${
          form?.is_section ? 'section-container' : ''
        }`}
        onClick={() => {
          if (form?.is_section && onSectionClick) {
            onSectionClick(form.id)
            return
          }
          if (!hasSubmissions) return
          setShowFormSubmissions(!showFormSubmissions)
        }}
        style={{
          cursor: form?.is_section
            ? 'pointer'
            : hasSubmissions
            ? 'pointer'
            : 'default',
          backgroundColor: 'transparent',
          transition: 'all 0.2s ease',
          borderLeft: form?.is_section
            ? '4px solid #ffc107'
            : '4px solid transparent',
        }}
        onMouseEnter={(e) => {
          if (form?.is_section) {
            e.currentTarget.style.backgroundColor = '#fff9e6'
            e.currentTarget.style.borderLeftColor = '#ffb300'
            e.currentTarget.style.transform = 'translateX(2px)'
          }
        }}
        onMouseLeave={(e) => {
          if (form?.is_section) {
            e.currentTarget.style.backgroundColor = 'transparent'
            e.currentTarget.style.borderLeftColor = '#ffc107'
            e.currentTarget.style.transform = 'translateX(0px)'
          }
        }}
      >
        <div className='flex-item-employee d-flex align-items-center position-relative'>
          <div
            className='chevron-container'
            style={{ width: '30px', display: 'flex', justifyContent: 'center' }}
          >
            {form?.is_section ? (
              <FontAwesomeIcon
                icon={faCaretRight}
                size='lg'
                className='mt-1'
                style={{
                  color: '#ffc107',
                  filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))',
                }}
              />
            ) : hasSubmissions ? (
              <>
                {!showFormSubmissions ? (
                  <FontAwesomeIcon
                    icon={faCaretRight}
                    size='lg'
                    className='mt-1'
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faCaretDown}
                    size='lg'
                    className='mt-1'
                  />
                )}
              </>
            ) : (
              <FontAwesomeIcon
                icon={faCaretDown}
                size='lg'
                className='mt-1 invisible'
              />
            )}
          </div>

          <div className='d-flex align-items-center ml-2'>
            <div
              className='icon-container'
              style={{
                width: '60px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {form?.is_section ? (
                <FontAwesomeIcon
                  icon={faLayerGroup}
                  size='3x'
                  color='#ffc107'
                  style={{
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.15))',
                  }}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faClipboardList}
                  size='3x'
                  color='#c87dfb'
                />
              )}
            </div>
            <Badge
              color={form?.is_section ? 'warning' : 'primary'}
              pill
              className='text-uppercase ml-2'
              style={{
                fontSize: '10px',
                fontWeight: 'bold',
                position: 'absolute',
                left: '90px',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            >
              {form?.is_section ? (
                <FontAwesomeIcon icon={faFolder} className='mr-1' />
              ) : null}
              {form?.is_section ? `SECTION` : 'Form'}
            </Badge>
          </div>
        </div>
        <div className='flex-item-employee py-4 position-relative'>
          {isEditingTitle && form?.created_by === user?.id ? (
            <input
              type='text'
              value={formTitle}
              onChange={(e) => setFormTitle(e.target.value)}
              onBlur={handleTitleSave}
              onKeyDown={handleTitleKeyDown}
              autoFocus
              className='form-control'
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '4px',
                padding: '4px 8px',
                fontSize: 'inherit',
                fontWeight: 'inherit',
              }}
            />
          ) : (
            <p
              role='button'
              onClick={(e) => {
                if (form?.created_by !== user?.id) return
                e.stopPropagation()
                setIsEditingTitle(true)
              }}
              className='mb-0'
              style={{
                cursor: form?.created_by !== user?.id ? 'default' : 'pointer',
                padding: '4px 8px',
                borderRadius: '4px',
                transition: 'background-color 0.2s',
                position: 'relative',
              }}
              onMouseEnter={(e) => {
                if (form?.created_by === user?.id) {
                  e.target.style.backgroundColor = '#f8f9fa'
                }
              }}
              onMouseLeave={(e) => {
                if (form?.created_by === user?.id) {
                  e.target.style.backgroundColor = 'transparent'
                }
              }}
              title={form?.created_by !== user?.id ? '' : 'Click to edit title'}
            >
              {formTitle}
              {form?.created_by === user?.id && (
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className='ml-2 text-muted'
                  style={{ fontSize: '12px', opacity: 0.6 }}
                />
              )}
            </p>
          )}
        </div>
        <p className='flex-item-employee py-4 '>
          {moment(form.created_at, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY')}
        </p>
        <div className='flex-item-employee'>
          {!form?.is_section && (
            <button
              onClick={(e) => {
                e.stopPropagation()
                setFormId(form.id)
                setShowTakeFormModal(true)
              }}
              className='btn btn-info'
            >
              Fill Form
            </button>
          )}
        </div>
        {form.created_by === user?.id || user?.access === 1 ? (
          <p className='py-4 '>
            <UncontrolledDropdown
              onClick={(e) => e.stopPropagation()}
              direction={lastForm ? 'up' : 'left'}
              className={lastForm ? 'last-form-dropdown' : ''}
            >
              <DropdownToggle
                className='actionToggle'
                role='button'
                size='sm'
                onClick={(e) => e.preventDefault()}
              >
                <FontAwesomeIcon icon={faEllipsis} size={'lg'} />
              </DropdownToggle>
              <DropdownMenu className='dropdown-menu-arrow course-dropdown'>
                <div
                  role='button'
                  onClick={() => {
                    if (onEditClick) {
                      onEditClick()
                    } else {
                      setShowEditFormModal(true)
                      setFormId(form.id)
                    }
                  }}
                  className='dropdown-item'
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Edit</span>
                </div>

                {!form?.is_section && (
                  <div
                    role='button'
                    className='dropdown-item'
                    onClick={() => {
                      setShowFormSettingsModal(true)
                      setFormId(form.id)
                    }}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <FontAwesomeIcon
                      icon={faGear}
                      style={{
                        marginRight: '10px',
                        width: '20px',
                        textAlign: 'center',
                      }}
                    />
                    <span>Settings</span>
                  </div>
                )}

                <div
                  role='button'
                  className='dropdown-item'
                  onClick={() => {
                    setShowAssignUsersModal(true)
                    setFormId(form.id)
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Assign Users</span>
                </div>

                {form?.remind_to_submit ? (
                  <div
                    role='button'
                    className='dropdown-item'
                    onClick={() => {
                      setShowFormSubmissionsModal(true)
                      setFormId(form.id)
                    }}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    <FontAwesomeIcon
                      icon={faClock}
                      style={{
                        marginRight: '10px',
                        width: '20px',
                        textAlign: 'center',
                      }}
                    />
                    <span>Scheduled Submissions</span>
                  </div>
                ) : null}

                <div
                  role='button'
                  onClick={() => deleteForm(form.id)}
                  className='dropdown-item'
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Delete</span>
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          </p>
        ) : (
          <p className='py-4 invisible'>
            {' '}
            <UncontrolledDropdown
              onClick={(e) => e.stopPropagation()}
              direction='down'
            >
              <DropdownToggle
                className='actionToggle'
                role='button'
                size='sm'
                onClick={(e) => e.preventDefault()}
              >
                <FontAwesomeIcon icon={faEllipsis} size={'lg'} />
              </DropdownToggle>
              <DropdownMenu className='dropdown-menu-arrow course-dropdown'>
                <div
                  role='button'
                  onClick={() => {
                    if (onEditClick) {
                      onEditClick()
                    } else {
                      setShowEditFormModal(true)
                      setFormId(form.id)
                    }
                  }}
                  className='dropdown-item'
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Edit</span>
                </div>

                <div
                  role='button'
                  className='dropdown-item'
                  onClick={() => {
                    setShowFormSettingsModal(true)
                    setFormId(form.id)
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faGear}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Settings</span>
                </div>

                <div
                  role='button'
                  className='dropdown-item'
                  onClick={() => {
                    setShowAssignUsersModal(true)
                    setFormId(form.id)
                  }}
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faUsers}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Assign Users</span>
                </div>

                <div
                  role='button'
                  onClick={() => deleteForm(form.id)}
                  className='dropdown-item'
                  style={{ display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faTrash}
                    style={{
                      marginRight: '10px',
                      width: '20px',
                      textAlign: 'center',
                    }}
                  />
                  <span>Delete</span>
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
          </p>
        )}
      </div>
      {showTakeFormModal && (
        <TakeFormModal
          formId={form.id}
          showTakeFormModal={showTakeFormModal}
          setShowTakeFormModal={(show) => {
            setShowTakeFormModal(show)
            if (!show && removeFillFormFromUrl) {
              removeFillFormFromUrl()
            }
          }}
          setHasSubmissions={setHasSubmissions}
          onFormSubmitted={() =>
            setSubmissionsRefreshKey((key) => key + 1)
          }
        />
      )}
      {showFormSubmissions && (
        <FormSubmissions
          formId={form.id}
          setShowFormSubmissions={setShowFormSubmissions}
          setHasSubmissions={setHasSubmissions}
          lastForm={lastForm}
          refreshKey={submissionsRefreshKey}
        />
      )}
    </>
  )
}

export default FormContainer
